import { render, staticRenderFns } from "./exampleMember.vue?vue&type=template&id=54582c84&"
import script from "./exampleMember.vue?vue&type=script&lang=js&"
export * from "./exampleMember.vue?vue&type=script&lang=js&"
import style0 from "./exampleMember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports